import styled from "styled-components";
import {JackpotBetWinDialogLogoDefaultBox} from "./jackpot-bet-win-dialog-logo.default.box";

export const JackpotBetWinDialogLogoMrgreenBox = styled(JackpotBetWinDialogLogoDefaultBox)`
    width: 140px;
    height: 91.8px;
`;